module.exports = __webpack_public_path__ + "media/wisdom.c80cc322.mp4";